import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

import ScrollToTop from './ScrollToTop';
import Header from '../Header';
import Footer from '../Footer';
import StepsMenu from '../StepsMenu';
import NavigationButtons from '../NavigationButtons';
import { SessionMessage, SignatureMessage } from '../Content/ErrorContent';

import { withApiData, withScreenData } from '../../hocs/withData';

const ErroMessage = ({ statusCode = '', pathname = '', validationErrors = {} }) => {
  // Field validation failures are rendered inline by the form itself.
  if (Object.keys(validationErrors).length > 0) return null;
  if (statusCode === 404 || statusCode === 422 || statusCode === 500) {
    if (pathname === '/declaration') {
      return <SignatureMessage />;
    }
    return <SessionMessage />;
  }
  return null;
};

const Page = ({
  children = null,
  className,
  dispatch = () => {},
  id = '',
  screen = null,
  ApiData = {},
}) => {
  const history = useHistory();
  const Pathname = history.location.pathname;
  const { statusCode, validationErrors = {} } = ApiData;

  useEffect(() => {
    if (screen !== null) {
      history.push(screen);
      dispatch({
        type: 'CHANGE_SCREEN',
        payload: {
          link: null,
        },
      });
    }
  }, [screen]);

  return (
    <>
      <ScrollToTop />
      <ErroMessage
        statusCode={statusCode}
        pathname={Pathname}
        validationErrors={validationErrors}
      />
      <Header />
      <div id={id} className={className}>
        <div className="container">
          <div className="content-wrap">
            {Pathname === '/success' ? null : <StepsMenu />}
            {children}
            {Pathname === '/success' || Pathname === '/evidence' ? null : (
              <NavigationButtons />
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default compose(connect(null, null), withApiData, withScreenData)(Page);
